import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 052D93D8-A1F1-450C-99F3-AEEE07D77CF4
 * name summit
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/summit.svg
 * tags
 */
export const SummitIcon = createSvgIcon(<><path d="M15,3H17L22,5L17,7V10.17L22,21H2L8,13L11.5,17.7L15,10.17V3Z" /></>, 'SummitIcon');
export default SummitIcon